module.exports = __webpack_public_path__ + "static/media/footer.41853e4f.svg";